import { Component, inject, signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgClass } from '@angular/common';
import { AppService } from '../core/config/app.service';

@Component({
    selector: 'setting',
    templateUrl: './theme-customizer.html',
    standalone: true,
    imports: [NgClass, NgScrollbarModule, FormsModule],
})
export class ThemeCustomizerComponent {
    private readonly appSetting = inject(AppService);
    readonly store = this.appSetting.indexState;

    readonly showCustomizer = signal(false);

    constructor(public storeData: Store<any>, public router: Router) {}

    reloadRoute() {
        globalThis.location.reload();
        this.showCustomizer.set(true);
    }
}
